// extracted by mini-css-extract-plugin
export default {"title":"DeleteMessageModal_title__MABhC","description":"DeleteMessageModal_description__EQLcL","btnCancel":"DeleteMessageModal_btnCancel__L7dXz"};